module.exports = __webpack_public_path__ + "media/icons/close-widget-alt-c1c84255.png";